<div id="newsList" class="ya-typography" (swiperight)=" navigateBack()">
  <ya-subheader [hasContent]="true" [disableNavigateBack]="true" (onNavigateBackClick)="navigateBack()">
    <div class="header-action-container">
      <div class="header-action-item">
        <a @plopInOut matRipple matRippleCentered="true" (click)="openFilterDialog()" matBadge="!" matBadgeSize="small"
          [matBadgeHidden]="locationFilterIds.length>0" class="header-tools-wrapper main-header-account">
          <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-standort"></div>
        </a>
      </div>
    </div>
  </ya-subheader>
  <div [@newsButtonEntering]="isLoaded" class="ya-page-content ya-page-content--webshop" id="newsComponent">
    <ng-container *ngIf="hasData; then pageTemplate else emptyTemplate"></ng-container>
    <ng-template #pageTemplate>
      <div class="news-map-tabs">
        <mat-tab-group mat-stretch-tabs dynamicHeight="true" [(selectedIndex)]="matGroupSelectedIndex"
          animationDuration="20ms">
          <mat-tab label="news">
            <div class="ya-page-content ya-page-content--padding ya-page-content--webshop">
              <div class="ya-item-list-container">
                <ng-container *ngFor="let news of newsList">
                  <div class="ya-content-item news-item news-button">
                    <div a11y_Button class="left" (click)="navigateToNewsDetail(news.id)">
                      <div class="news-date-wrapper ya-caption">
                        <div class="news-detail-like">
                          <ya-favoritebutton [contentType]="contentType.News" [likeStatus]="news.like"
                            [modelId]="news.id" [customClass]="'custom-favorite-button'">
                          </ya-favoritebutton>
                        </div>
                      </div>
                      <div class="aspect-ratio-box">
                        <div class="aspect-ratio-box-inside">
                          <div class="aspect-ration-img-box">
                            <img class="ya_image" [src]="news.image_photo" alt="" />
                          </div>
                        </div>
                      </div>
                      <div class="news-content" (click)="navigateToNewsDetail(news.id)">
                        <div class="news-content-wrapper">
                          <h2 class="title">
                            {{news.label}}
                          </h2>
                          <ng-container *ngIf="!isSmallView">
                            <div class="news-content-container">
                              <p class="content-text" [innerHTML]="news.text"></p>
                              <div class="inline-icon hyp-filter-svg" inlineSVG="shop-icons.svg#ya-hypersoft-news">
                              </div>
                            </div>
                          </ng-container>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </div>
            </div>
          </mat-tab>
        </mat-tab-group>
      </div>
    </ng-template>
    <ng-template #emptyTemplate>
      <ya-emptypage></ya-emptypage>
    </ng-template>
  </div>
</div>